var _style, _path, _path2, _line, _g, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke-width:25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,45.947;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.2,773.3L849.5,94c4.3-7,13.4-9.2,20.4-4.8l27.8,17.5c7,4.4,9,13.6,4.5,20.5L464,796.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.7,761.7l63.4,45l-42.1,51.6c-8.1,10-18.9,17.4-31.1,21.4l-164.2,54.5c-9.6,3.2-19.9,3.6-29.7,1.1 c-26.9-6.8-77.9-27.1-90.5-85.3c-7.3-33.6-1.3-58.2,8.3-75.6c12.5-22.7,39.5-33,63.9-24.6l182,62.7L416.7,761.7z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 706.2,
    y1: 339.6,
    x2: 742,
    y2: 362.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M863.2,743.4c0,55.2-44.7,99.9-99.9,99.9c-55.2,0-99.9-44.7-99.9-99.9c0-55.2,44.7-99.9,99.9-99.9 C818.4,643.6,863.2,688.3,863.2,743.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 741.7,
    y1: 786.8,
    x2: 741.7,
    y2: 786.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 774.2,
    y1: 754.3,
    x2: 790.4,
    y2: 738.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 806.7,
    y1: 721.8,
    x2: 806.7,
    y2: 721.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 783.5,
    y1: 796.9,
    x2: 783.5,
    y2: 796.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 816.7,
    y1: 763.7,
    x2: 816.7,
    y2: 763.7
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M716.7,850.5l10.2,4.3c22.2,9.4,36.7,31.2,36.7,55.4V937"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M809.9,850.5l-10.2,4.3c-22.2,9.4-36.7,31.2-36.7,55.4V937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/Golf.77aff952.svg";
export { ForwardRef as ReactComponent };